import { create } from 'zustand'

/**
 * - unknown  — not signed in, or status not loaded yet (never blocks)
 * - required — signed in, no date of birth recorded: show the prompt
 * - verified — recorded as 18+
 * - blocked  — under 18, on this account or declared on this device
 */
export type AgeGateStatus = 'unknown' | 'required' | 'verified' | 'blocked'

interface AgeGateState {
  status: AgeGateStatus
  /** The user the status belongs to, so a different account on the same session is re-checked. */
  userId: string | null
  setStatus: (status: AgeGateStatus, userId: string | null) => void
  reset: () => void
}

/**
 * Shared so other blocking prompts can wait their turn: the Terms re-acceptance prompt holds
 * off until this is 'verified', because two native modals stacked on iOS stop taking touches.
 */
export const useAgeGateStore = create<AgeGateState>((set) => ({
  status: 'unknown',
  userId: null,
  setStatus: (status, userId) => set({ status, userId }),
  reset: () => set({ status: 'unknown', userId: null }),
}))
